export default __webpack_public_path__ + "static/media/Product-2.129e86a3.jpg";